
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ABTestDetails } from '@/components/ab-test/ABTestDetailsView';
import { toast } from '@/components/ui/use-toast';
// TODO: Implement API call to fetch AB test data
// import { getMockABTest } from '../utils/mockABTestData';

export function useABTestDetails(testId: string) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [abTest, setABTest] = useState<ABTestDetails | null>(null);

  useEffect(() => {
    // TODO: Replace with real API call
    // const fetchedABTest = getMockABTest(testId || '');

    // Temporary: set null until API is implemented
    setABTest(null);
    setLoading(false);
  }, [testId, navigate]);

  const handleBackToList = () => {
    navigate('/ab-test/list');
  };
  
  const handleFinalizeTeste = (testId: string) => {
    // In a real app, this would be an API call to update the test status
    if (abTest) {
      setABTest({
        ...abTest,
        status: 'finished'
      });
    }
  };

  const handleTrafficUpdate = (videoId: string, percentage: number) => {
    // In a real app, this would be an API call to update the traffic distribution
    if (abTest) {
      const updatedVideos = abTest.videos.map(video => {
        if (video.id === videoId) {
          return {
            ...video,
            trafficPercentage: percentage
          };
        }
        return video;
      });
      
      setABTest({
        ...abTest,
        videos: updatedVideos
      });
    }
  };

  return {
    loading,
    abTest,
    handleBackToList,
    handleFinalizeTeste,
    handleTrafficUpdate
  };
}
